import { render } from "./NotificationSelectAudienceFilter.vue?vue&type=template&id=040ba0b2&scoped=true&ts=true"
import script from "./NotificationSelectAudienceFilter.vue?vue&type=script&lang=ts"
export * from "./NotificationSelectAudienceFilter.vue?vue&type=script&lang=ts"

import "./NotificationSelectAudienceFilter.vue?vue&type=style&index=0&id=040ba0b2&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040ba0b2"]])

export default __exports__